import company from './company'
import member from './member'

export default {
    company,
    member
}



// WEBPACK FOOTER //
// ./src/api/dashboard/index.js